import React from 'react';
import style from './Aprobar.module.css';
import CardAprobarContainer from '../../Components/CardAprobarContainer/CardAprobarContainer'
const Aprobar = () => {
  return (
    <div className={style.container}>
    <CardAprobarContainer/>
    
    </div>
  );
};

export default Aprobar;
